<template>
  <pt-batch-operation-form ref="form" class="pt-batch-operation-form__withData">
    <div :class="$style.btns">
      <el-button type="primary" v-intervalclick="{func:createLot,time:500}">立即创建</el-button>
			<el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </pt-batch-operation-form>
</template>

<script>
import PtBatchOperationForm from './index'
export default {
  name: 'pt-batch-operation-form__withData',
  components: {
    'pt-batch-operation-form': PtBatchOperationForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  methods: {
    createLot () {
      this.form.validate().then(formValue => {
        this.form.submit()
      })
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>
<style module lang="less">
.btns{
  margin-top:20px;
}
</style>
